import { useI18n } from "./i18n";
import type { Channel, ChannelOption } from "./vend";

/**
 * The store's payment methods as a radio group, in the store's order
 * (Aqua's rows, radio dot first). A method the store offers but this app
 * cannot complete yet (the card) is shown, disabled, as 準備中.
 */
export function ChannelPicker({
  options,
  value,
  onChange,
  disabled,
}: {
  options: ChannelOption[];
  value: Channel | null;
  onChange: (c: Channel) => void;
  disabled?: boolean;
}) {
  const { t } = useI18n();
  return (
    <div className="v-channels" role="radiogroup" aria-label={t("vend.method")}>
      {options.map((o) => (
        <button
          key={o.channel}
          type="button"
          role="radio"
          aria-checked={value === o.channel}
          className="aseed-payment-row v-channel"
          disabled={disabled || !o.available}
          onClick={() => onChange(o.channel)}
        >
          <span className="v-channel__dot" aria-hidden="true" />
          <span className="v-channel__badge" aria-hidden="true">
            {BADGE[o.channel] ?? o.channel.slice(0, 1).toUpperCase()}
          </span>
          <span className="v-channel__label">
            {t(`payment.channel.${o.channel}`)}
            {o.available ? null : <span className="v-channel__note">{t("vend.method.unavailable")}</span>}
          </span>
        </button>
      ))}
    </div>
  );
}

/** Neutral short marks, not the brands' logos. */
const BADGE: Record<string, string> = {
  paypay: "P",
  rakuten: "R",
  aupay: "au",
  docomopay: "d",
  wechat: "W",
  alipay: "A",
  aeonpay: "Æ",
  payjp: "💳",
};
